<script lang="ts" setup>
import type { PayPageConfig } from '../configs/types'
import { getPayPageConfig } from '../configs/brands'

defineProps<{
  item: any
  isActive?: boolean
}>()

const config: PayPageConfig = getPayPageConfig()
const tagGradient = config.theme?.colors?.tagGradient || 'linear-gradient(90deg, #F0509B 0%, #9B5CF0 100%)'
</script>

<template>
  <div class="nm-coin-card">
    <!-- 营销角标 chip:左上角,渐变底 / 白字 9 / 800 / 圆角 14-0-10-0 -->
    <div
      v-if="item.cornerTip === 1 && item.marketingText"
      class="nm-coin-chip"
      :style="{ background: tagGradient }"
    >
      {{ item.marketingText }}
    </div>

    <!-- 金额 + 赠币 -->
    <div class="nm-coin-amount">
      {{ item.coinsBuy }}
    </div>
    <div v-if="item.coinsBonus" class="nm-coin-bonus">
      +{{ item.coinsBonus }} {{ config.texts.coins || 'Coins' }}
    </div>

    <!-- 价格 -->
    <div class="nm-coin-price">
      ${{ item.price }}
    </div>
  </div>
</template>

<style scoped>
/* 有意不使用 text-n-text-1/2 工具类:父级 PaymentInlinePanel.default.vue 的 scoped 样式里
   有 :deep(.text-n-text-1){ color: var(--pay-card-text) },特异性高于子组件 scoped 类,会把设计色改掉 */
.nm-coin-card {
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px 8px 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.nm-coin-chip {
  position: absolute;
  top: 0;
  left: 0;
  min-width: 46px;
  max-width: calc(100% - 14px);
  height: 16px;
  padding: 0 6px;
  box-sizing: border-box;
  display: block;
  border-radius: 14px 0 10px 0;
  font-size: 9px;
  font-weight: 800;
  line-height: 16px;
  text-align: center;
  letter-spacing: 0.2px;
  color: #FFFFFF;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nm-coin-amount {
  font-family: 'Baloo 2', 'Nunito Sans', system-ui, sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  color: #2B1B34;
}

.nm-coin-bonus {
  margin-top: 2px;
  font-size: 12px;
  font-weight: 700;
  line-height: 14px;
  color: #7C4DE8;
}

.nm-coin-price {
  margin-top: 6px;
  font-size: 13px;
  font-weight: 700;
  line-height: 16px;
  color: #71607E;
}
</style>
